import {connect} from 'react-redux';
import React, {Component} from 'react';

class Convenience extends Component {
    static defaultProps = {
        convenience: {}
    };

    render() {
        return (
            <div id="convenience" className="rent-convenience">
                <h2>{this.props.convenience.title}</h2>
                <div className="rent-convenience-items clearfix">
                    {this.props.convenience.items.map(item =>
                        <div key={item.name} className="rent-convenience-itm">
                            <div className="rent-convenience-itm-icon">
                                <img src={item.imgURL} alt=""/>
                            </div>
                            <div className="rent-convenience-itm-name">
                                {item.name}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Convenience);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Convenience.js